import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { FinanceState } from "../models/FinanceState";

const setVisiablePaymentForm = (state: FinanceState, action: PayloadAction<Visiable>) => {
    state.visiablePaymentForm = action.payload.visiable;
}

export default setVisiablePaymentForm;